var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs-wrapper"},[_c('b-tabs',{attrs:{"lazy":""}},[_c('b-tab',{attrs:{"title":_vm.$t('globals.installations')}},[_c('ulu-installations-comulative-chart')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }